import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 16,
  },
  item: {
    borderBottomWidth: 1,
    borderBottomColor: "#2C2C2E",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 12,
  },
  icon: {
    width: 27,
    height: 19,
    marginTop: 6,
    marginRight: 12,
  },
  content: {
    flex: 1,
  },
  title: {
    fontSize: 21,
    fontWeight: "bold",
  },
  description: {
    fontSize: 14,
    color: "#939394",
    marginTop: 10,
  },
});
